

















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Channel } from "@/services/channels/types";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
import { Getter } from "vuex-class";
import CreatePostContextMenu from "@/components/channels/CreatePostContextMenu.vue";

    @Component({
        components: {
            CreatePostContextMenu
        }
    })
export default class ChannelsTileView extends Vue {
        @Prop() channels!: Channel[];
        // local state
        @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
        permitionEnum = PermitionEnum;
        havePermition = HavePermition;
        // lifecycle hooks

        // computed
        get isAdmin() : boolean {
            return this.havePermition(this.getCurrentUser.permissions,
                this.permitionEnum[this.permitionEnum.AdminPrivilege]);
        }

        // methods
        updateChannelRoute(channelId: string) {
            if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel])) {
                return {
                    name: "updatechannel",
                    params: { channelId: channelId }
                };
            } else {
                return {
                    name: "editorupdatechannel",
                    params: { channelId: channelId }
                };
            }
        }

        // events
        toggleFavorite(channel: Channel) {
            this.$emit("toggleFavorite", channel);
        }

        previewChannel(channelId: string, name: string) {
            this.$emit("previewChannel", channelId, name);
        }

        copyChannel(channelId: string) {
            this.$emit("copyChannel", channelId);
        }

        channelInfo(channelId: string) {
            this.$emit("channelInfo", channelId);
        }

        deleteChannel(channelId: string, channelName: string) {
            this.$emit("deleteChannel", { channelId: channelId, name: channelName });
        }

        onOpenItemsModal(data: any) {
            this.$emit("openItemsModal", data);
        }

        onOpenContentModal(channelId: string, type: string) {
            this.$emit("openHtmlItemModal", channelId, type);
        }
}
